module.exports = __webpack_public_path__ + "static/media/ogc-logo.d0b74ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ogc-logo.png
// module id = 634
// module chunks = 0